import { render, staticRenderFns } from "./BOLReceipt.vue?vue&type=template&id=5b7c3a03&scoped=true"
import script from "./BOLReceipt.vue?vue&type=script&lang=js"
export * from "./BOLReceipt.vue?vue&type=script&lang=js"
import style0 from "./BOLReceipt.vue?vue&type=style&index=0&id=5b7c3a03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7c3a03",
  null
  
)

export default component.exports